<template>
  <v-card title="Team Lead" subtitle="This info is private and used for 72 admin purposes only.">
    <template v-slot:append>
      <ActionButton :to="{ name: 'MyProfile' }" variant="text" icon>
        <v-icon icon="mdi-pencil"></v-icon>
      </ActionButton>
    </template>
    <v-card-text>
      <v-row>
        <v-col>
          <v-list v-if="teamLeader">
            <v-list-item :prepend-avatar="avatar">
              <v-list-item-title
                >{{ teamLeader.first_name }} {{ teamLeader.last_name }}</v-list-item-title
              >
              <v-list-item-subtitle>{{ teamLeader.email_address }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item><strong>Phone:</strong> {{ teamLeader.phone_number }}</v-list-item>
            <v-list-item
              ><strong>Address:</strong>
              <v-row
                ><v-col
                  >{{ teamLeader.street_address }} <br />
                  {{ teamLeader.city }}, {{ teamLeader.state }} {{ teamLeader.postal_code }}
                  <br />
                  {{ teamLeader.country }}</v-col
                ></v-row
              >
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { IUserDTO, UserDTO } from '@/dtos';
import { computed, toRef } from 'vue';
import blankProfileUrl from '@/assets/blankProfile.webp';

interface Props {
  teamLeader: IUserDTO;
}
const props = defineProps<Props>();
const teamLeader = toRef(props, 'teamLeader', new UserDTO());

const avatar = computed(() => {
  return teamLeader.value.avatar ? teamLeader.value.avatar.url : blankProfileUrl;
});
</script>
